import { render, staticRenderFns } from "./ExpandTable.vue?vue&type=template&id=989bf206"
import script from "./ExpandTable.vue?vue&type=script&lang=js"
export * from "./ExpandTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports